import type { PropsWithChildren } from 'react'
import React, { useEffect } from 'react'
import { Block, H3, Text, useWizard } from '@mote/ui'
import { useOnboarding } from '../context'
import type { QuestionValues } from '../typings'

export interface StepProps {
  index: number
  surveyKey: QuestionValues['key']
  trackingKey: QuestionValues['trackingKey']
  title: QuestionValues['question']
  subtitle?: string
}

export const Step = (props: PropsWithChildren<StepProps>) => {
  const { children, title, index, trackingKey, surveyKey: key } = props
  const { isCurrentStep } = useWizard()
  const isActiveStep = isCurrentStep(index)
  const { updateState } = useOnboarding()

  useEffect(() => {
    if (!isActiveStep) return
    updateState({ surveyKey: key })
  }, [isActiveStep])

  if (!isActiveStep) return null

  return (
    <Block layout='vertical' gap={48}>
      <Block gap={8}>
        <H3 text='2xl' fontWeight={700}>
          {title}
        </H3>
        {props.subtitle && (
          <Text
            fontSize='md'
            lineHeight='md'
            fontWeight='normal'
            color='grey.d3'
          >
            {props.subtitle}
          </Text>
        )}
      </Block>
      <Block gap={16} spreadX>
        {children}
      </Block>
    </Block>
  )
}
